import { ref } from "vue-demi";

// Pinia
import { defineStore } from "pinia";

// Utils
import { formData, postData } from "@utils";

// Plugin
import { useToast } from "vue-toastification/composition";

export const useCashReportStore = defineStore("cashReport", () => {
  // Initial

  const toast = useToast();

  const imageDialog = ref(false);
  const imageFile = ref(null);
  const imageUploadLoading = ref(false);
  const imageUploadId = ref(null);

  const addEditDialog = ref(false);
  const editData = ref(null);

  // Görüntüleme dialogu için state
  const viewDialog = ref(false);
  const viewData = ref(null);

  const openImageDialog = (id) => {
    imageDialog.value = true;
    imageUploadId.value = id;
  };

  const imageSaveFn = async () => {
    imageUploadLoading.value = true;
    console.log(imageFile.value);
    try {
      const data = new FormData();
      data.append("method", "addMediaCashForm");
      data.append("id", imageUploadId.value);
      data.append("file", imageFile.value);

      const response = await formData(data);
      if (!response.error) {
        location.reload();
        imageDialog.value = false;
      }
    } catch (e) {
      // API hataya girdi
      toast.error(`Hata ${e}`);
    } finally {
      imageUploadLoading.value = false;
    }
  };

  const imageDeleteFn = async (id, uploadid) => {
    if (confirm("Bu görseli silmek istediğinize emin misiniz?") == true) {
      try {
        const response = await postData({
          method: "deleteMediaCashForm",
          id,
          uploadid,
        });
        if (!response.error) {
          location.reload();
        }
      } catch (e) {
        // API hataya girdi
        toast.error(`Hata ${e}`);
      } finally {
      }
    }
  };

  const startProcessFn = async (id) => {
    if (confirm("Süreci başlatmak istediğinize emin misiniz?") == true) {
      try {
        const response = await postData({
          method: "cashFormCompleteFileUpload",
          id,
        });
        if (!response.error) {
          location.reload();
        }
        toast.error(`Hata ${response.msg}`);
      } catch (e) {
        // API hataya girdi
        toast.error(`Hata ${e}`);
      } finally {
      }
    }
  };

  // Dialog kontrolü
  const openAddDialog = () => {
    editData.value = null;
    addEditDialog.value = true;
  };

  const openEditDialog = (data) => {
    editData.value = data;
    viewDialog.value = false;
    setTimeout(() => {
      addEditDialog.value = true;
    }, 200);
  };

  const closeAddEditDialog = () => {
    addEditDialog.value = false;
    editData.value = null;
  };

  // Görüntüleme dialog kontrolü
  const openViewDialog = (data) => {
    viewData.value = data;
    viewDialog.value = true;
  };

  const closeViewDialog = () => {
    viewDialog.value = false;
    viewData.value = null;
  };

  return {
    imageDialog,
    imageUploadId,
    imageFile,
    imageUploadLoading,
    openImageDialog,
    imageDeleteFn,
    imageSaveFn,
    startProcessFn,
    addEditDialog,
    editData,
    openAddDialog,
    openEditDialog,
    closeAddEditDialog,
    // Görüntüleme dialog exports
    viewDialog,
    viewData,
    openViewDialog,
    closeViewDialog,
  };
});
